// extracted by mini-css-extract-plugin
export var aboutPeople = "aboutPeople-module--about-people--bd9aa";
export var aboutPeople__bottomText = "aboutPeople-module--about-people__bottom-text--ab07a";
export var aboutPeople__col = "aboutPeople-module--about-people__col--e0186";
export var aboutPeople__heading = "aboutPeople-module--about-people__heading--3562c";
export var aboutPeople__img = "aboutPeople-module--about-people__img--add6f";
export var aboutPeople__list = "aboutPeople-module--about-people__list--1fb6a";
export var aboutPeople__text = "aboutPeople-module--about-people__text--0445b";
export var aboutPeople__title = "aboutPeople-module--about-people__title--99a0c";
export var aboutPeople__wrapper = "aboutPeople-module--about-people__wrapper--39018";